import { ApolloClient, ApolloLink, split, InMemoryCache } from '@apollo/client'
import { HttpLink } from '@apollo/client/link/http'
import { getMainDefinition } from '@apollo/client/utilities'
import { onError } from '@apollo/client/link/error'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient } from 'graphql-ws'

import { API_V2, getAuthRedirectUrl, getSubscriptionUrl, getApiAuthOptions } from './environment'

const wsLink = new GraphQLWsLink(
  createClient({
    url: getSubscriptionUrl(),
  })
)

const httpLink = new HttpLink({
  uri: API_V2,
  ...getApiAuthOptions(),
})

const errorLink = onError(({ networkError }) => {
  // if API call fails due to authentication error, redirect to login page
  if (networkError && networkError.statusCode === 401) {
    window.location = getAuthRedirectUrl()
  }
})

const wsHttpLink = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, wsHttpLink]),
})

apolloClient.defaultOptions = {
  query: {
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
}

export default apolloClient
